/**
 * LoadingSkeleton - Minimal Loading State
 * 
 * Shows the layout without data - faster perceived load
 * User knows content is coming
 */

import React from 'react';
import './loadingskeleton.css';

export default function LoadingSkeleton() {
  return (
    <div className="loading-skeleton">
      {/* Hero skeleton */}
      <div className="skeleton-block skeleton-block--large">
        <div className="skeleton-shimmer" />
      </div>

      {/* Stats skeletons */}
      <div className="skeleton-row">
        <div className="skeleton-block skeleton-block--medium">
          <div className="skeleton-shimmer" />
        </div>
        <div className="skeleton-block skeleton-block--medium">
          <div className="skeleton-shimmer" />
        </div>
        <div className="skeleton-block skeleton-block--medium">
          <div className="skeleton-shimmer" />
        </div>
      </div>

      {/* Action buttons skeletons */}
      <div className="skeleton-row skeleton-row--buttons">
        <div className="skeleton-block skeleton-block--button">
          <div className="skeleton-shimmer" />
        </div>
        <div className="skeleton-block skeleton-block--button">
          <div className="skeleton-shimmer" />
        </div>
      </div>

      {/* Activity skeletons */}
      <div className="skeleton-column">
        <div className="skeleton-block skeleton-block--line">
          <div className="skeleton-shimmer" />
        </div>
        <div className="skeleton-block skeleton-block--line">
          <div className="skeleton-shimmer" />
        </div>
        <div className="skeleton-block skeleton-block--line">
          <div className="skeleton-shimmer" />
        </div>
      </div>
    </div>
  );
}
